module.exports = __webpack_public_path__ + "img/dark.412ca67e.svg";